import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { removeNote, saveNotesToStorage } from '../../../models/NoteModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { removeProjectMember } from '../../../models/ProjectModel';


const DeleteProjectMemberModal = ({showModal, setShowModal, project_unique_id, memberData, modalKey, fetchProjectMembers, limit, page}) => {

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate();

    const { state } = useAuth(); 

    let user_data = state.user_data;
    
    const loader = document.getElementById('loading');

    const [loading, setLoading] = useState(false);
    
    const [_user_id, setUserId] = useState('');

    const closeModal = () =>{
        setUserId('');
        setShowModal(false);
    }

    useEffect(() => {
        // This effect will be called whenever noteData changes
        if (memberData) {
            setUserId(memberData._user_id);
        }
    }, [project_unique_id, memberData, modalKey]);


    const deleteProjectMember = async() => {
        // Start the loading state
        loader.style.display = 'block';
    
        try {
          const response = await removeProjectMember(user_data.user_token, project_unique_id, _user_id);
    
          if (response.status) {
            toast.success(response.message);
    
            closeModal();
    
            fetchProjectMembers(limit, page);

            setNotificationCount(localStorage.getItem('unread_notification_count'));
          }
          else{
            toast.error(response.message);
          }  
    
        } catch (error) {
          apiError(error);

          if (error.response.data.invalid_token==1) {
            navigate('/re-login');
          }
        }
    
        // Stop the loading state
        loader.style.display = 'none';
    }

    return (
        <Modal show={showModal} onHide={closeModal}>
            <Modal.Header closeButton>
                <Modal.Title>Remove Member</Modal.Title>
            </Modal.Header>
    
            <Modal.Body>
                <p>Do you want to remove this member from this project ?</p>
            </Modal.Body>
    
            <Modal.Footer>
                <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={deleteProjectMember}>Delete</button>
            </Modal.Footer>
        </Modal>
    );  

}; 


export default DeleteProjectMemberModal;